import { Component, ViewChild } from '@angular/core';
import { AuthUserApps, AuthUserApps_Search } from '../model/auth-user-apps';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../services/app.service';
import { Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../services/filter-data.service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { TableSetting } from 'projects/Shared-Lib/component/table/table-class';
import { ReturnClass } from 'projects/Shared-Lib/model/search-result';

@Component({
  selector: 'app-auth-user-apps',
  templateUrl: './auth-user-apps.component.html',
  styleUrls: ['./auth-user-apps.component.css']
})
export class AuthUserAppsComponent {
  @ViewChild('acc') acc: NgbAccordionItem;

  ControllerName = 'AuthUserApps';
  model: AuthUserApps_Search;
  TableSetting: TableSetting;
  currentRoute: string;
  CanCreate: boolean = true;
  TableData: ReturnClass;

  constructor(private app: AppService, private router: Router, private dlgService: DialogService,
    private filterService: FilterDataService, private dataSer: DataService) {
    this.model = new AuthUserApps_Search();
    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'UserID';
    this.TableSetting.ItemTitle = (item: AuthUserApps) => {
      return `[${item.UserID}]${item.ApplicationID}`;
    };
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'UserAccount', header: 'User Account', cell: (element: AuthUserApps) => `${element.UserAccount}` },
      { columnDef: 'ApplicationID', header: 'Application ID', cell: (element: AuthUserApps) => `${element.ApplicationID}` },
      { columnDef: 'IsEnabled', header: 'IsEnabled', cell: (element: AuthUserApps) => `${element.IsEnabled ? 'Y' : 'N'}` },
      { columnDef: 'UpdatedBy', header: 'Update User', cell: (element: AuthUserApps) => `${element.UpdatedBy == null ? '' : element.UpdatedBy}` },
      { columnDef: 'UpdatedDateTime', header: 'Update Date', cell: (element: AuthUserApps) => `${element.UpdatedDateTime.ToDateTimeString()}` }
    ];

    this.app.currentResource.subscribe(data => {
      this.TableSetting.CanUpdate = false;
      this.TableSetting.CanDelete = data.CanDelete;
      this.CanCreate = data.CanCreate;
    });
  }

  ngOnInit() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  Search() {
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.model.filter = LasttimeSearchInfo.Filter;
      }
    }

    this.filterService.ChangeSearchInfo(this.currentRoute, this.model.filter);
    this.dataSer.getData(this.ControllerName + '/List', this.model.filter, (res) => {
      this.TableData = {
        draw: this.model.filter.PageIndex,
        pagingSize: this.model.filter.PageSize,
        recordsTotal: res.TotalCount,
        recordsFiltered: res.TotalCount,
        data: res.DataList
      };
    }, (res) => {
    }, () => {
      setTimeout(() => this.app.SetLoadingState(false), 0);
    });
  }

  onChangeTableInfo(TableInfo: any) {
    this.model.filter.SortBy = TableInfo.SortBy;
    this.model.filter.IsAsc = TableInfo.IsAsc;

    this.Search();
  }

  onChangePageInfo(PageInfo: any) {
    this.model.filter.PageSize = PageInfo.PageSize;
    this.model.filter.PageIndex = PageInfo.CurrentPage;

    this.Search();
  }

  Delete(DeleteItem: any) {
    this.app.SetLoadingState(true);
    this.dataSer.DeleteData(`${this.ControllerName}?userid=${DeleteItem.UserID}&appid=${DeleteItem.ApplicationID}`, null, (res) => {
      this.Search();
    },
      (err) => {
        let result = this.dlgService.ErrorInformation(err.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      },
      () => {
        this.app.SetLoadingState(false);
      });
  }
}
